/// <amd-module name="Repos/Views/Settings/Repositories-Policies/RestClient/Policy" />
/**
 * ---------------------------------------------------------
 * Generated file, DO NOT EDIT
 * ---------------------------------------------------------
 *
 * See following wiki page for instructions on how to regenerate:
 *   https://aka.ms/azure-devops-client-generation
 *
 * Configuration file:
 *   tfs\web\extensions\code\vss-code-web\repos\views\settings\repositories-policies\genclient.json
 */

import { IVssPageContext, IVssRestClient, IVssRestClientOptions, RestClients } from "VSS/Platform/Context";
import { RestClientBase } from "VSS/Platform/RestClientBase";
import { deserializeVssJsonObject } from "VSS/Platform/Util/Serialization";

import * as Policy from "Repos/Common/Contracts/Policy";
import * as VS_Services from "VSS/Platform/Contracts/WebApi";

export interface IPolicyRestClient extends IVssRestClient {
    /**
     * Create a policy configuration of a given policy type.
     * 
     * @param configuration - The policy configuration to create.
     * @param project - Project ID or project name
     */
    createPolicyConfiguration(configuration: Policy.PolicyConfiguration, project: string): Promise<Policy.PolicyConfiguration>;
    /**
     * Delete a policy configuration by its ID.
     * 
     * @param project - Project ID or project name
     * @param configurationId - ID of the policy configuration to delete.
     */
    deletePolicyConfiguration(project: string, configurationId: number): Promise<void>;
    /**
     * Get a list of policy configurations in a project.
     * 
     * @param project - Project ID or project name
     * @param scope - [Provided for legacy reasons] The scope on which a subset of policies is defined.
     * @param policyType - Filter returned policies to only this type
     */
    getPolicyConfigurations(project: string, scope?: string, policyType?: string): Promise<VS_Services.PagedList<Policy.PolicyConfiguration>>;
    /**
     * Update a policy configuration by its ID.
     * 
     * @param configuration - The policy configuration to update.
     * @param project - Project ID or project name
     * @param configurationId - ID of the existing policy configuration to be updated.
     */
    updatePolicyConfiguration(configuration: Policy.PolicyConfiguration, project: string, configurationId: number): Promise<Policy.PolicyConfiguration>;
}

class PolicyRestClient extends RestClientBase implements IPolicyRestClient {
    constructor(options: IVssRestClientOptions) {
        super(options);
    }

    /**
     * Create a policy configuration of a given policy type.
     * 
     * @param configuration - The policy configuration to create.
     * @param project - Project ID or project name
     */
    public async createPolicyConfiguration(
        configuration: Policy.PolicyConfiguration,
        project: string
        ): Promise<Policy.PolicyConfiguration> {

        return this.beginRequest<Policy.PolicyConfiguration>({
            apiVersion: "5.0-preview.1",
            method: "POST",
            routeTemplate: "{project}/_apis/policy/Configurations/{configurationId}",
            routeValues: {
                project: project
            },
            body: configuration
        });
    }

    /**
     * Delete a policy configuration by its ID.
     * 
     * @param project - Project ID or project name
     * @param configurationId - ID of the policy configuration to delete.
     */
    public async deletePolicyConfiguration(
        project: string,
        configurationId: number
        ): Promise<void> {

        return this.beginRequest<void>({
            apiVersion: "5.0-preview.1",
            method: "DELETE",
            routeTemplate: "{project}/_apis/policy/Configurations/{configurationId}",
            routeValues: {
                project: project,
                configurationId: configurationId
            }
        });
    }

    /**
     * Get a list of policy configurations in a project.
     * 
     * @param project - Project ID or project name
     * @param scope - [Provided for legacy reasons] The scope on which a subset of policies is defined.
     * @param policyType - Filter returned policies to only this type
     */
    public async getPolicyConfigurations(
        project: string,
        scope?: string,
        policyType?: string
        ): Promise<VS_Services.PagedList<Policy.PolicyConfiguration>> {

        const queryValues: any = {
            scope: scope,
            policyType: policyType
        };

        return this.beginRequest<Response>({
            apiVersion: "5.0-preview.1",
            routeTemplate: "{project}/_apis/policy/Configurations/{configurationId}",
            routeValues: {
                project: project
            },
            queryParams: queryValues,
            returnRawResponse: true
        }).then(async response => {
            const body = <VS_Services.PagedList<Policy.PolicyConfiguration>>await response.text().then(deserializeVssJsonObject);
            body.continuationToken = response.headers.get("x-ms-continuationtoken");
            return body;
        });
    }

    /**
     * Update a policy configuration by its ID.
     * 
     * @param configuration - The policy configuration to update.
     * @param project - Project ID or project name
     * @param configurationId - ID of the existing policy configuration to be updated.
     */
    public async updatePolicyConfiguration(
        configuration: Policy.PolicyConfiguration,
        project: string,
        configurationId: number
        ): Promise<Policy.PolicyConfiguration> {

        return this.beginRequest<Policy.PolicyConfiguration>({
            apiVersion: "5.0-preview.1",
            method: "PUT",
            routeTemplate: "{project}/_apis/policy/Configurations/{configurationId}",
            routeValues: {
                project: project,
                configurationId: configurationId
            },
            body: configuration
        });
    }

}

export const PolicyClientName = "Repos.Settings.Policies.Policy.IPolicyRestClient";

export function getPolicyClient(pageContext: IVssPageContext, options?: IVssRestClientOptions): IPolicyRestClient {
    return pageContext.getRestClient<IPolicyRestClient>(PolicyClientName, options);
}

RestClients.add(PolicyClientName, { 
    factory: PolicyRestClient,
    options: {
        resourceAreaId: "fb13a388-40dd-4a04-b530-013a739c72ef",
        serviceInstanceType: "00025394-6065-48ca-87d9-7f5672854ef7"
    }
});
